import { useEffect, useState } from "react";
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const ConversionChart = () => {
  const { lang, t } = useLang();
  const c = t.dash.chart;
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get("/stats/monthly").then((res) =>
      setData(
        res.data.map((r) => ({
          ...r,
          label: new Date(`${r.month}-01`).toLocaleDateString(lang === "fr" ? "fr-BE" : "en-GB", {
            month: "short",
            year: "2-digit",
          }),
        }))
      )
    );
  }, [lang]);

  if (data.length === 0) return null;

  return (
    <div className="border border-white/10 bg-[#111111] p-6 mb-10" data-testid="conversion-chart">
      <p className="text-xs uppercase tracking-widest text-white/40 mb-5">{c.title}</p>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} barGap={4}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 12 }} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 12 }} axisLine={false} tickLine={false} width={30} />
            <YAxis yAxisId="right" orientation="right" tick={{ fill: "rgba(96,165,250,0.6)", fontSize: 12 }} axisLine={false} tickLine={false} width={40} tickFormatter={(v) => `€${v}`} />
            <Tooltip
              cursor={{ fill: "rgba(255,255,255,0.04)" }}
              contentStyle={{ background: "#0d0d0d", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 8, fontSize: 13 }}
              labelStyle={{ color: "rgba(255,255,255,0.6)" }}
            />
            <Legend wrapperStyle={{ fontSize: 12 }} iconType="circle" iconSize={8} />
            <Bar dataKey="leads" name={c.leads} fill="#FF7900" radius={[4, 4, 0, 0]} maxBarSize={36} />
            <Bar dataKey="converted" name={c.converted} fill="#34d399" radius={[4, 4, 0, 0]} maxBarSize={36} />
            <Line yAxisId="right" type="monotone" dataKey="revenue" name={c.revenue} stroke="#60a5fa" strokeWidth={2} dot={{ r: 3, fill: "#60a5fa" }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
